import React from "react"
import { FaCheck } from "react-icons/fa"

const SaveButton = ({
	handleSave,
	hasWriteSchedulesPermission,
	hasWriteChairsPermission,
	modifiedFields,
	sandbox,
	hasChanges,
	validationErrors,
	hasRequestPermission,
	isTomorrowMode,
	isEditingPatient
}) => {
	if (!hasWriteSchedulesPermission && isTomorrowMode) {
		console.error(
			"No write schedules permission and is tomorrow mode - this should never happen"
		)
		return null
	} else if (
		hasWriteSchedulesPermission ||
		(hasWriteChairsPermission &&
			modifiedFields.assignedChair &&
			!modifiedFields.assignedNurse &&
			!modifiedFields.acuity) ||
		sandbox
	) {
		return (
			<>
				<button
					onClick={handleSave}
					className={`bg-customBlue text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-customBlue-dark transition duration-150 flex items-center ${
						!hasChanges() || Object.keys(validationErrors).length > 0
							? "opacity-50 cursor-not-allowed"
							: ""
					}`}
					disabled={!hasChanges() || Object.keys(validationErrors).length > 0}
				>
					<FaCheck className="mr-2" /> <span>Update Patient</span>
				</button>
			</>
		)
	} else if (
		hasWriteChairsPermission &&
		modifiedFields.assignedChair &&
		(modifiedFields.assignedNurse || modifiedFields.acuity)
	) {
		return (
			<>
				<button
					onClick={handleSave}
					className={`bg-customBlue text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-customBlue-dark transition duration-150 flex items-center ${
						!hasChanges() || Object.keys(validationErrors).length > 0
							? "opacity-50 cursor-not-allowed"
							: ""
					}`}
					disabled={!hasChanges() || Object.keys(validationErrors).length > 0}
				>
					<FaCheck className="mr-2" />{" "}
					<span>Submit Chairs & Request CN Modification</span>
				</button>
			</>
		)
	} else if (
		hasRequestPermission &&
		(modifiedFields.acuity || (modifiedFields.assignedNurse && !modifiedFields.assignedChair))
	) {
		return (
			<>
				<button
					onClick={handleSave}
					className={`bg-customBlue text-white text-sm font-semibold px-4 py-2 rounded flex items-center hover:bg-customBlue-dark ${
						!isEditingPatient ? "opacity-50 cursor-not-allowed" : ""
					}`}
					disabled={!isEditingPatient}
				>
					<FaCheck className="mr-2" /> Request CN Modification
				</button>
			</>
		)
	} else {
		return (
			<>
				<button
					className={`bg-customBlue text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-customBlue-dark transition duration-150 flex items-center ${
						!hasChanges() || Object.keys(validationErrors).length > 0
							? "opacity-50 cursor-not-allowed"
							: ""
					}`}
					disabled={!hasChanges() || Object.keys(validationErrors).length > 0}
				>
					<FaCheck className="mr-2" /> Update Patient
				</button>
			</>
		)
	}
}

export default SaveButton
